// Gendered COPY helper (client-safe, no lexicon) — the classifier lives in lib/gender.ts (server/scripts only; it re-exports
// these). Founder order 30/09/26: the site writes "פנוי" / "פנויה" by the person's gender, and a NEUTRAL phrase when unknown —
// never a slash form ("פנוי/ה"). scripts/qa/gender-slash-audit.mjs blocks new slash forms at deploy.
export type Gender = 'm' | 'f' | 'u';
/** The ONE helper for gendered copy: g(gender, { m: 'פנוי היום', f: 'פנויה היום', u: 'זמינות היום' }). Unknown → u. */
export function g<T>(gender: string | null | undefined, forms: { m: T; f: T; u: T }): T {
  return gender === 'm' ? forms.m : gender === 'f' ? forms.f : forms.u;
}
export const asGender = (v: unknown): Gender => (v === 'm' || v === 'f' ? v : 'u');
